import { taskType } from '@/typings/allType';
import dayjs from 'dayjs';
import { useEffect, useState, useRef, MutableRefObject } from 'react';
import './Schedule.scss';
const Schedule = (props: { data: { localDate: string; list: taskType[] }[] }) => {
    console.log(props.data, 'schedule');
    const [schedule, setSchedule] = useState<{ localDate: string; list: taskType[] }[]>([]);
    const [activeDateIndex, setDateIndex] = useState(0);
    useEffect(() => {
        props.data.forEach(i => {
            i.list.length &&
                i.list.forEach(t => {
                    const startHour = dayjs(t.workStartTime).hour();
                    const endHour = dayjs(t.workEndTime).hour();
                    const startMin = dayjs(t.workStartTime).minute();
                    const endMin = dayjs(t.workEndTime).minute();
                    t.startTime = Number(`${startHour}.${startMin > 0 ? (startMin / 60).toFixed(2).split('.')[1] : 0}`);
                    t.endTime = Number(`${endHour}.${endMin > 0 ? (endMin / 60).toFixed(2).split('.')[1] : 0}`);
                });
        });
        setSchedule(props.data);
    }, [props.data]);
    useEffect(() => {
        timesRef.current.scrollTop = 422;
    }, [activeDateIndex]);
    const timesRef: MutableRefObject<any> = useRef(null);
    return (
        <div className="Schedule">
            <div className="weeks">
                {schedule.slice(0, 7).map(w => {
                    return <div key={w.localDate + 'week'}>{dayjs(w.localDate).format('ddd')}</div>;
                })}
            </div>
            <div className="dates">
                {schedule.map((d, index) => {
                    return (
                        <div
                            key={d.localDate + 'date'}
                            className={activeDateIndex === index ? 'date-active' : ''}
                            onClick={() => {
                                setDateIndex(index);
                            }}
                        >
                            {dayjs(d.localDate).format('D')}
                            {d.list.length ? <span></span> : ''}
                        </div>
                    );
                })}
            </div>
            <div className="times" id="times" ref={timesRef}>
                {[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23].map(t => {
                    return (
                        <div className="time-i" key={t + 'time'}>
                            <span>{t < 12 ? `${t} am` : t > 12 ? `${t - 12} pm` : 'Noon'}</span>
                            <span className="time-line"></span>
                        </div>
                    );
                })}
                {schedule.length &&
                    schedule[activeDateIndex].list.map(c => {
                        return (
                            <div
                                key={c.taskTitle + 'task'}
                                className={c.taskOrder === 'next' ? 'time-child next-task' : 'time-child'}
                                style={{
                                    top: (c.startTime || 0) * 53 + 7,
                                    height:
                                        ((c.endTime || 24) - (c.startTime || 0) < 0.5
                                            ? 0.5
                                            : (c.endTime || 24) - (c.startTime || 0)) * 53,
                                }}
                            >
                                <div className="task-name">{c.taskTitle}</div>
                                {(c.endTime || 24) - (c.startTime || 0) > 1 ? (
                                    <div className="task-location">{c.workAddress}</div>
                                ) : (
                                    ''
                                )}
                            </div>
                        );
                    })}
            </div>
        </div>
    );
};
export default Schedule;
